import React from 'react';
import NextIcon from '@moda/icons/next-20';
import { ControlLink, Stack, AspectRatioBox } from '@moda/om';
import { CarouselCell } from '../../Grid';
import { LookCellsGridProps } from '../LookCellsGrid';
import { getLookCellsGridScenario } from '../getLookCellsGridScenario';

import './LookCellsGridContent.scss';

export const LookCellsGridContent: React.FC<LookCellsGridProps> = ({ looks, galleryViewUrl }) => {
  const { hasGalleryViewLinkPlaceholder } = getLookCellsGridScenario(looks.length);

  return (
    <div className="LookCellsGridContent swiper-wrapper">
      {looks.map(carouselCell => (
        <div className="swiper-slide" key={carouselCell.id}>
          <CarouselCell carouselCell={carouselCell} />
        </div>
      ))}

      {hasGalleryViewLinkPlaceholder && (
        <div className="LookCellsGridContent__gallery-view-clickable-wrapper swiper-slide">
          <ControlLink
            className="LookCellsGridContent__gallery-view-clickable"
            underlined={false}
            to={galleryViewUrl}
          >
            <AspectRatioBox maxHeight={540} maxWidth={340}>
              <Stack
                space={2}
                alignItems="center"
                justifyContent="center"
                className="LookCellsGridContent__gallery-view-text"
              >
                Gallery
                <Stack alignItems="center" direction="horizontal" space={2}>
                  View
                  <NextIcon />
                </Stack>
              </Stack>
            </AspectRatioBox>
          </ControlLink>
        </div>
      )}
    </div>
  );
};
